export const LOADING = "LOADING"
export const GET_TRENDING = "GET_TRENDING"
export const GET_RANDOM = "GET_RANDOM"
export const GET_SEARCH = "GET_SEARCH"
export const ADD_TO_FAVORITES = "ADD_TO_FAVORITES"
export const GET_FAVOURITES = "GET_FAVOURITES"